module.exports = __webpack_public_path__ + "img/SefLinkLogo.2a4b3164.svg";